export const topics = [
  {
    id: "zongyi-mingchang-2024",
    title: "综艺名场面年度回顾：从出圈到塌房的完整时间线",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20a%20vintage%20television%20set%20with%20stage%20lights%20and%20golden%20confetti%2C%20muted%20cream%20and%20burnt%20orange%20tones%2C%20magazine%20cover%20aesthetic%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20background&width=800&height=600&seq=kanliao-topic-01&orientation=landscape",
    summary:
      "把一整年里最出圈、最反转、最让人意外的节目片段按时间顺序重新排列，附上播出背景与舆论走向，帮你在十分钟内补齐所有名场面。",
    updateTime: "2024-06-18",
    articleCount: 3,
    hotScore: 9820,
    tags: ["综艺", "名场面", "时间线"],
  },
  {
    id: "wanghong-fanche",
    title: "网红翻车现场盘点：那些从爆火到翻车的转折点",
    categoryId: "influencer",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20of%20a%20ring%20light%20and%20microphone%20on%20a%20warm%20terracotta%20backdrop%2C%20moody%20amber%20lighting%2C%20paper%20texture%2C%20magazine%20photography%20style%2C%20minimal%20clean%20background&width=800&height=600&seq=kanliao-topic-02&orientation=landscape",
    summary:
      "从直播口误到人设崩塌，我们把每起舆论事件的起点、发酵节点和最终走向整理清楚，不做评判，只还原过程。",
    updateTime: "2024-06-12",
    articleCount: 3,
    hotScore: 8940,
    tags: ["网红", "直播", "舆论"],
  },
  {
    id: "yingshi-xuanfa",
    title: "影视宣发背后的博弈：一部作品如何被推上热搜",
    categoryId: "screen",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20film%20reels%20and%20a%20clapperboard%20on%20a%20warm%20beige%20paper%20surface%2C%20soft%20side%20lighting%2C%20muted%20amber%20and%20cream%20palette%2C%20magazine%20cover%20aesthetic%2C%20minimal%20background&width=800&height=600&seq=kanliao-topic-03&orientation=landscape",
    summary:
      "宣发预算、物料节奏、口碑维护与档期选择，四个维度拆解一部作品从定档到上映的完整传播链。",
    updateTime: "2024-06-05",
    articleCount: 3,
    hotScore: 7310,
    tags: ["影视", "宣发", "口碑"],
  },
  {
    id: "dianjing-zhuanhui",
    title: "电竞转会期风云实录：阵容重组背后的取舍逻辑",
    categoryId: "esports",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20moody%20editorial%20shot%20of%20a%20mechanical%20keyboard%20and%20headset%20on%20a%20dark%20walnut%20desk%2C%20amber%20rim%20lighting%2C%20paper%20grain%2C%20magazine%20photography%2C%20minimal%20clean%20composition&width=800&height=600&seq=kanliao-topic-04&orientation=landscape",
    summary:
      "转会窗口的每一次官宣背后，都藏着预算、战术与选手意愿三方拉扯。这份合集按赛区整理，帮你看懂休赛期的所有操作。",
    updateTime: "2024-05-29",
    articleCount: 3,
    hotScore: 6680,
    tags: ["电竞", "转会", "赛区"],
  },
  {
    id: "pinpai-yingxiao-fanche",
    title: "品牌营销翻车案例研究：一次失误如何演变成舆论危机",
    categoryId: "marketing",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20marketing%20print%20mockups%20and%20color%20swatches%20on%20cream%20paper%2C%20burnt%20orange%20accents%2C%20soft%20top%20lighting%2C%20magazine%20aesthetic%2C%20minimal%20clean%20background&width=800&height=600&seq=kanliao-topic-05&orientation=landscape",
    summary:
      "从文案踩雷到代言争议，逐个还原品牌传播翻车的完整链路，并附上被验证有效的公关处理方式。",
    updateTime: "2024-05-21",
    articleCount: 3,
    hotScore: 5920,
    tags: ["品牌", "公关", "案例"],
  },
  {
    id: "yinyuejie-xianchang",
    title: "音乐节现场名场面合集：那些被全场大合唱的瞬间",
    categoryId: "music",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20editorial%20photo%20of%20an%20outdoor%20festival%20stage%20silhouette%20with%20crowd%20and%20string%20lights%2C%20amber%20and%20cream%20tones%2C%20soft%20haze%2C%20magazine%20cover%20aesthetic%2C%20minimal%20composition&width=800&height=600&seq=kanliao-topic-06&orientation=landscape",
    summary:
      "按场地和阵容整理每个音乐节的高光时刻，包含曲目单、返场情况与现场氛围记录，方便你回看和补课。",
    updateTime: "2024-05-14",
    articleCount: 3,
    hotScore: 5240,
    tags: ["音乐节", "现场", "大合唱"],
  },
  {
    id: "duanshipin-baogeng",
    title: "短视频爆梗溯源档案：一个梗是怎么火起来的",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20close%20up%20of%20a%20smartphone%20propped%20on%20a%20wooden%20stand%20with%20warm%20amber%20screen%20glow%2C%20paper%20texture%20backdrop%2C%20soft%20lighting%2C%20magazine%20aesthetic%2C%20minimal%20clean%20composition&width=800&height=600&seq=kanliao-topic-07&orientation=landscape",
    summary:
      "每个爆梗都有它的第一条视频。我们把热门梗的原始出处、扩散路径和变体玩法整理成档案，追根溯源一次看全。",
    updateTime: "2024-05-08",
    articleCount: 3,
    hotScore: 4870,
    tags: ["短视频", "梗", "溯源"],
  },
  {
    id: "suren-zouhong",
    title: "素人走红成长观察：流量到来之后发生了什么",
    categoryId: "influencer",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20portrait%20of%20an%20empty%20vintage%20chair%20with%20a%20warm%20spotlight%20and%20soft%20long%20shadow%2C%20cream%20and%20amber%20palette%2C%20paper%20grain%2C%20magazine%20photography%2C%20minimal%20background&width=800&height=600&seq=kanliao-topic-08&orientation=landscape",
    summary:
      "从偶然走红到被持续关注，我们记录素人创作者在流量前后的内容变化、心态调整与选择分岔。",
    updateTime: "2024-04-30",
    articleCount: 3,
    hotScore: 4130,
    tags: ["素人", "成长", "流量"],
  },
];